import type { StudioCreateSubTab, StudioSelectedMode } from "@/lib/inputPersistence";

/** In-flight label on transform buttons (Task 4 — no persona names except unused here). */
export function getTransformLoadingButtonLabel(args: {
  selectedMode: StudioSelectedMode;
  createSubTab: StudioCreateSubTab;
  repurposePlatformCount: number;
  isCreateImageAction: boolean;
  isImageTransform: boolean;
}): string {
  const { selectedMode, createSubTab, repurposePlatformCount, isCreateImageAction, isImageTransform } = args;
  if (isCreateImageAction) return "Generating image…";
  if (isImageTransform) return "Transforming…";
  if (selectedMode === "create" && createSubTab === "repurpose") {
    const n = Math.max(1, repurposePlatformCount);
    return `Repurposing across ${n} platforms…`;
  }
  if (selectedMode === "create") return "Drafting…";
  if (selectedMode === "write") return "Polishing…";
  return "Polishing…";
}
